import { OrderStatus } from '../types/order/orderStatus';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/order/status/list';

export namespace OrderStatusRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<OrderStatus>> => {
    return (await http.post(LIST, payload)).data;
  };
}
